import React, { createContext, useContext } from 'react';
import FullPageLoader from './FullPageLoader';
import useLoadingState from '../hooks/useLoadingState';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading deve essere usato all\'interno di LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const loadingState = useLoadingState();

  return (
    <LoadingContext.Provider value={loadingState}>
      {children}
      <FullPageLoader 
        isVisible={loadingState.isLoading}
        message={loadingState.loadingMessage}
        type={loadingState.loadingType}
      />
    </LoadingContext.Provider>
  );
}; 